import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { StudentsGridDataService } from 'common/services/data-services/admin/students/students-grid-data.service';
import { environment } from 'src/environments/environment';
import { API_URL } from 'common/constants/sm-constants';
import { StudentsModel } from 'common/models/page-models/student/formmodel/student-data.model';
import { StudentsListingModel } from 'common/models/page-models/student/gridmodel/student-grid.data.model';
import { StudentsGridMetaModel } from 'common/models/page-models/student/gridmodel/student-grid.meta.model';

@Injectable({
    providedIn: 'root'
})
export class StudentsGridWidgetService extends GridWidgetService<StudentsModel, StudentsListingModel> {
    constructor(protected override ds: StudentsGridDataService, protected systemService: SystemService) {
        super(ds);
    }

 

    getMetaModel(): MetaModel {
        const meta = new StudentsGridMetaModel().getMetaModel();
        return meta;
    }

    
    async getFilterOptions(filterMetaModel: any) {
        const urlList = [{ url: environment.apiUrl + API_URL.getGroupBatchList, payload: '' }, 
                { url: environment.apiUrl + API_URL.branchList, payload: '' }, 
                { url: environment.apiUrl + API_URL.zoneList, payload: '' },
                ];
        await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data) => {
            // console.log(filterMetaModel)
            filterMetaModel.properties.batchID.options = (data[0]).details;
            filterMetaModel.properties.branch_name.options = (data[1]).details;
            filterMetaModel.properties.region.options = (data[2]).details;
        })
    }
}